var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 17,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fill-primary",
    d: "M4.272 6.704a.472.472 0 1 1-.548-.769L8.525 2.51l.013-.005c.03-.02.062-.03.095-.043l.025-.01a.234.234 0 0 1 .05-.02c.02-.003.042-.002.063-.001a.781.781 0 0 0 .049 0 .3.3 0 0 1 .068.001c.025.006.049.019.074.028.033.012.066.022.096.042a.02.02 0 0 0 .006.003c.002 0 .005.001.007.003l4.881 3.425a.472.472 0 1 1-.542.774L8.802 3.473l-4.53 3.231Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#150F2F",
    fillRule: "evenodd",
    d: "M1.714 13.288a.473.473 0 0 0 0 .945h14.173a.473.473 0 0 0 0-.945H14.47V8.71h1.417c.26 0 .472-.212.472-.472v-2.22a.473.473 0 0 0-.199-.386L9.074.619a.472.472 0 0 0-.546 0L1.44 5.632a.47.47 0 0 0-.2.385v2.22c0 .261.212.473.473.473h1.417v4.577l-1.417.001Zm8.504-4.578v4.578H7.383V8.71h2.835Zm3.307 4.578h-2.362V8.71h2.362v4.578ZM2.186 6.262 8.8 1.584l6.614 4.678v1.503H2.187V6.262Zm1.89 2.448h2.362v4.578H4.076V8.71Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#150F2F",
    d: "M17.068 16.064a.473.473 0 0 0 0-.945H.533a.473.473 0 0 0 0 .945h16.535Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.2ed3365f.svg";
export { ForwardRef as ReactComponent };